<div class="header-custom">
  <div (click)="bukaDrawer()" class="drawer-btn">
    <span style="margin-top: -10px;">
      <i nz-icon nzType="menu" style="color: #005EB8; font-size: 18px; font-weight: 700;"></i>
    </span>
  </div>

  <div class="title-app">
    <span class="theme-text">Event</span>
    <!-- <span class="theme-text">BINUS TFI Event</span> -->
  </div>


  <div class="profile" >
    <!-- <button class="menu-arrow bg-secondary text-white" nzShape="circle" nz-button>
      <i nz-icon nzType="user" nzTheme="outline"></i>
    </button> -->
    <div nz-dropdown [nzDropdownMenu]="notification" nzPlacement="bottomRight">
      <nz-badge [nzStyle]="{ backgroundColor: 'orange' }" style="margin-top: 5px;" [nzCount]="notificationTotal" [nzOverflowCount]="999">
        <div style="width: 22px; height: 22px; margin-top:5px; background-position: center; background-repeat: no-repeat; background-size: cover; background-image: url('./../../../../../assets/images/bell.png');">
        </div>
      </nz-badge>
    </div>
    <nz-divider nzType="vertical" style="margin-left:15px; margin-right:15px; background:#6c757d;height: 99%; width:2px; opacity:0.1;"></nz-divider>
    <div class="user-image" style="margin-right:15px; width: 35px; height: 35px; border-radius: 35px; background-position: center; background-repeat: no-repeat; background-size: cover; background-image: url('./../../../../../assets/images/user-logo.png');">
      <!-- <img src="" style="object-fit: cover;" alt=""> -->
    </div>
    <div nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomRight" class="profile-info" style="margin-left: 5px;">
      <span class="theme-text">{{ userProfile.name? userProfile.name: userProfile.fullname }}</span>
      <span class="user-role">{{ userProfile.isAdmin? 'Admin':'Student' }}</span>
    </div>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li class="user-header text-center border-bottom" >
      <img src="../../../../../assets/images/user-logo.png" class="img-circle user-image" alt="User Image" style="margin-left:15px; margin-right:15px; margin-top:25px; width: 50%;">

      <p>
        <span class="theme-text"> {{userProfile.fullname | titlecase}}
        </span><br/>
        <span class="user-role">
          <small>{{userProfile.isAdmin?'Admin':'Student' | titlecase}}</small>
        </span>
      </p>
    </li>
    <!-- <li class="border-bottom" nz-menu-item>My Profile</li> -->
    <li nz-menu-item (click)="logout()">Sign Out</li>
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #notification="nzDropdownMenu">
  <ul nz-menu style="width:250px" class="notification-event">
    <li class="border-bottom"  nz-menu-item *ngFor="let notification of notificationList">
      <div  (click)="detailNotification(notification)">
        <small style="color: #96999c;">{{notification.notificationDateTime | date:"EEEE, dd MMM yyyy 'at' HH:mm"}}</small>
        <p>{{notification.message}}</p>
      </div>
    </li>
  </ul>
</nz-dropdown-menu>
